import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom'; // if using react-router for URL params
import { HotelType } from "../../../backend/src/shared/types";
import HotelCard from '../components/HotelCard/HotelCard';

type Props = {
  hotels: HotelType[];
  holidayType?: string; // to pass the type via props
  holidayCountry?: string;
};

const HolidayTypeHotelsList: React.FC<Props> = ({ hotels, holidayType, holidayCountry }) => {
  const [displayedHotels, setDisplayedHotels] = useState<HotelType[]>([]);
  const { type } = useParams<{ type: string }>(); // to get the type from URL params
  const { country } = useParams<{ country: string }>(); // to get the type from URL params
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const updateDisplayedHotels = () => {
    const selectedType = holidayType || type || 'All Inclusive'; // fallback to All Inclusive if no type is provided
    const selectedCountry = holidayCountry || country || ''; // fallback to All Inclusive if no type is provided
    const filteredHotels = hotels
      .filter(
        hotel =>
          hotel.type.includes(selectedType) &&
          hotel.country.includes(selectedCountry)
      )
      .sort(() => Math.random() - 0.5)
      .slice(0, 50);

    setDisplayedHotels(filteredHotels);
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    updateDisplayedHotels();
  }, [hotels, holidayType, type]);

  return (
    <>
      {displayedHotels.length === 0 ? '' :
        <div className="relative flex w-full bg-white">
          {/* Left arrow */}
          {displayedHotels.length > 4 && (
            <div className="absolute -left-9 top-1/2 transform -translate-y-1/2">
              <button
                className="p-2 bg-gray-200 rounded-full shadow-md hover:bg-halo-pink hover:text-white transition-colors z-10"
                onClick={scrollLeft}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
            </div>
          )}

          <div
            ref={scrollContainerRef}
            className="flex overflow-x-scroll scrollbar-hide space-x-6 w-full justify-between"
          >
            {displayedHotels.map((hotel) => (
              <div key={hotel._id} className="flex-shrink-0">
                <HotelCard hotel={hotel} />
              </div>
            ))}
          </div>

          {/* Right arrow */}
          {displayedHotels.length > 4 && (
            <div className="absolute -right-9 top-1/2 transform -translate-y-1/2">
              <button
                className="p-2 bg-gray-200 rounded-full shadow-md hover:bg-halo-pink hover:text-white transition-colors z-10"
                onClick={scrollRight}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
      }
    </>
  );
};

export default HolidayTypeHotelsList;
